module.exports = __webpack_public_path__ + "img/employee-health.ece32831.svg";